// extracted by css-extract-rspack-plugin
export default {"root":"root-2vPit","closeIcon":"closeIcon-1mdhi","image":"image-2Nz-t"};